import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import RAMembersPortalButton from './RAMembersPortalButton';
import RAMembersPortalFAQ from './RAMembersPortalFAQ';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import './ra-members-portal.scss';

import { addQueryParam, getMultilineText, getOauthReturnUrl } from '../../../../../general/js/utils';
import { shouldDisplayRAMembersPortalButton } from './ra-members-portal-helpers';

class RAMembersPortal extends Component {
    constructor(props) {
        super(props);
        this.handleRAMembersPortalClick = this.handleRAMembersPortalClick.bind(this);
        this.getOauthRAMembersPortalRedirectUri = this.getOauthRAMembersPortalRedirectUri.bind(this);
    }

    handleRAMembersPortalClick(event) {
        event.preventDefault();
        const { actions, formData } = this.props;

        actions.handleRedirectToRAMembersPortal({
            raMembersPortalUrl: formData.raMembersPortalUrl,
            secutixRAMemberPortalUrl: formData.raMembersPortalSecutixUrl,
            secutixPointOfSaleId: formData.raMembersPortalSecutixPointOfSaleId,
            secutixVirtualOperator: formData.raMembersPortalSecutixVirtualOperator,
            redirectUri: this.getOauthRAMembersPortalRedirectUri()
        });
    }

    getOauthRAMembersPortalRedirectUri() {
        const { renderedComponent } = this.props;

        const returnUri = getOauthReturnUrl({
            useEncode: false
        });

        if (returnUri.includes('account/profile')) {
            return encodeURIComponent(addQueryParam(returnUri, 'componentToRender', renderedComponent));
        }

        return encodeURIComponent(returnUri);
    }

    render() {
        const {
            formData,
            accountData
        } = this.props;
        const {
            raMembersPortalTitle,
            raMembersPortalCriteria,
            raMembersPortalInformation,
            raMembersPortalImage,
            raMembersPortalFAQTitle,
            raMembersPortalFAQs
        } = formData;

        const { raMemberId } = accountData;

        const texts = getMultilineText(raMembersPortalInformation);
        const showPortalLink = shouldDisplayRAMembersPortalButton(raMembersPortalCriteria, raMemberId);

        return (
            <Fragment>
                <h1>{raMembersPortalTitle}</h1>
                <div className="ramembers-portal">
                    <div className='intro'>
                        <div className='text-image-button'>
                            <div className='text'>
                                {texts.map((introText) => (
                                    <div
                                        key={uniqueId()}
                                        dangerouslySetInnerHTML={{ __html: introText }}
                                    />
                                ))}
                            </div>
                            <div className='ramembers-portal-buttons'>
                                { showPortalLink &&
                                <RAMembersPortalButton onRAMembersClick = {this.handleRAMembersPortalClick} buttonText="Go to Portal" buttonColor="blue"></RAMembersPortalButton>}
                            </div>
                        </div>
                        <div className='form'>
                            <div className='text'>
                                {texts.map((introText) => (
                                    <div
                                        key={uniqueId()}
                                        dangerouslySetInnerHTML={{ __html: introText }}
                                    />
                                ))}
                            </div>
                            <div className='image image--titled'>
                                <img className='lazyautosizes lazyloaded'
                                    data-sizes='auto'
                                    alt=''
                                    sizes='499px'
                                    srcSet={raMembersPortalImage.src}>
                                </img>
                            </div>
                        </div>

                    </div>
                    <RAMembersPortalFAQ title={raMembersPortalFAQTitle} questions={raMembersPortalFAQs} ></RAMembersPortalFAQ>
                </div>
            </Fragment >
        );
    }
}

RAMembersPortal.propTypes = {
    formData: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        homePageTicketsData: state.userAccount.homePageTicketsData,
        loadHomePageTicketsDataErrorMessages: state.userAccount.loadHomePageTicketsDataErrorMessages,
        isTicketsDataLoadedSuccessful: state.userAccount.isTicketsDataLoadedSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            handleRedirectToRAMembersPortal: bindActionCreators(userAccountActions.handleRedirectToRAMembersPortal, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RAMembersPortal);
